export default __webpack_public_path__ + "static/media/ai-chat-icon.2f2367cc.svg";